module.exports = { "default": require("core-js/library/fn/object/is-frozen"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-bootstrap/~/babel-runtime/core-js/object/is-frozen.js
 ** module id = 452
 ** module chunks = 0
 **/